<div class="pages" [style.padding-top]="paddingTop() + 'px'" (scroll)="onScroll()" (wheel)="onWheel()" #pagesEl>
  @if (pdf.value()) {
    @for (page of pages(); track page.key) {
      <canvas
        [attr.data-index]="$index"
        inViewNew
        [width]="page.width"
        [height]="page.height"
        [class.rendered]="loaded().get($index)"
        (onInView)="loadPage($index)"
        (click)="canvasClick($index)"
      ></canvas>
    }
  }
</div>
